module.exports = __webpack_public_path__ + "img/teamAnalytics.aa9522ed.png";